.contextWindowAnchor {
  position: relative;
}

.contextWindow {
  z-index: 2001;
  border: 1px black solid;
  margin: 0;
  padding: 4px;
  background-color: rgb(250, 250, 250);
  box-shadow: 6px 6px 6px rgb(64, 64, 64, 0.5);
  transition: opacity 0.25s linear;
  justify-content: flex-start;
  position: absolute;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  resize: both;
  overflow: auto;
  max-height: 95vh;
  max-width: 95vw;
}

.contextWindowTitle {
  border-bottom: 1px black dashed;
  box-sizing: unset;
  padding-bottom: 4px;
  margin: 0 4px 3px 4px;
  height: 24px;
  line-height: 24px;
  max-height: 24px;
  cursor: grab;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 8px);
}

.contextWindowTitle.moving {
  cursor: grabbing;
}

.contextWindowTitleText {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 16px);
}

.contextWindowTitleClose {
  display: flex;
  color: black;
  height: 16px;
  width: 16px;
  border-radius: 3px;
  margin-left: 2px;
  cursor: pointer;
  line-height: 16px;
}

.contextWindowTitleClose:hover {
  background-color: black;
  color: white;
}

.contextWindowBody {
  overflow: auto;
  padding-bottom: 8px;
  margin-right: 4px;
  height: calc(100% - 40px);
}

.contextWindowBody::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.contextWindowBody::-webkit-scrollbar-track {
  background: white;
  border-radius: 8px;
}

.contextWindowBody::-webkit-scrollbar-thumb {
  background: lightgrey;
  border: none;
  border-radius: 8px;
}

.contextWindowBody::-webkit-scrollbar-thumb:hover {
  background: grey;
}
